export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(6, 182, 212, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(6, 182, 212, 0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-5 gap-12 mb-16">
          <div className="md:col-span-3">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/d5a68c31-78ff-4f7c-bf4e-65f5a709fee4.png" 
                alt="DISTRIEM LTDA Logo" 
                className="h-10 w-auto"
              />
              <span className="text-2xl font-bold">DISTRIEM LTDA</span>
            </div>
            <p className="text-gray-400 mb-8 text-sm">
              Securing digital freedom worldwide
            </p>
            <div className="space-y-2 mb-6">
              <p className="text-gray-300 text-sm">CARRERA 5 27 08</p>
              <p className="text-gray-300 text-sm">Pereira, Colombia</p>
            </div>
            <div className="space-y-3">
              <a 
                href="mailto:contact@distriemltda.com" 
                className="block text-cyan-400 hover:text-cyan-300 transition-colors text-sm"
              >
                contact@distriemltda.com
              </a>
              <a 
                href="tel:+16507302658" 
                className="block text-cyan-400 hover:text-cyan-300 transition-colors text-sm"
              >
                +1 650 730 2658
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-4">
              <li>
                <a href="#about" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="#features" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  Features
                </a>
              </li>
              <li>
                <a href="#security" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  Security Standards
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-gray-400 text-sm">
              © {currentYear} DISTRIEM LTDA. All rights reserved
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-cyan-500 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-cyan-500 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a 
                href="https://github.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-cyan-500 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-github-fill text-lg"></i>
              </a>
            </div>
            <div className="flex items-center gap-2">
              <p className="text-gray-400 text-sm italic">Made with security in mind</p>
              <span className="text-gray-400">•</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
